import { ProductViewModel } from '@/types/api'

export interface PDPSeoValues {
    h1: string
    title: string
    description: string
}

export const getPDPSeoValues = (data?: ProductViewModel | null): PDPSeoValues => {
    const h1 = data?.pageH1 || `${data?.nameFa || ''} ${data?.brand?.nameFa || ''}`.trim()
    const title = data?.pageTitle || h1
    const description =
        data?.descriptionMeta || `خرید اینترنتی ${h1} با بهترین قیمت و ضمانت بازگشت از فروشگاه آنلاین خانومی`

    return { h1, title, description }
}
